export default "__VITE_ASSET__KwZeDKRs__"